import request from '@/utils/request'

// 客户列表
export function customerList(params) {
  return request({ url: '/taxapi/tax/customerList', method: 'get', params })
}

// 客户详情
export function customerDetail(params) {
  return request({ url: '/taxapi/tax/customerDetail', method: 'get', params })
}

// 创客列表
export function creatorList(params) {
  return request({ url: '/taxapi/tax/creatorList', method: 'get', params })
}

// 创客详情
export function creatorDetail(params) {
  return request({ url: '/taxapi/tax/creatorDetail', method: 'get', params })
}

// 创客基本资料
export function creatorBaseInfo(params) {
  return request({ url: '/taxapi/tax/creatorBaseInfo', method: 'get', params })
}

// 创客基本资料-承揽协议-身份证文件流获取
export function showPic(params) {
  return request({ url: '/taxapi/tax/showPic', method: 'get', params })
}

// 下载合同
export function downloadContract(params) {
  return request({ url: '/taxapi/tax/signShow', method: 'get', params: params.data, responseType: params.responseType })
}

// 下载身份证
export function downloadPic(params) {
  return request({ url: '/taxapi/tax/downloadPic', method: 'get', params: params.data, responseType: params.responseType })
}

// 创客列表/个税报表/增值及附加税报表
export function reportForms({ url, params, responseType }) {
  return request({ url, method: 'get', params, responseType })
}
